import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, KanbanSquare, Percent } from "lucide-react";

export const FalconMark = ({ className = "", boxed = false }) => (
  <Link to="/" className={`inline-flex items-center ${boxed ? "bg-[#0B132B] rounded-lg px-3 py-2" : ""} ${className}`} data-testid="nav-logo">
    <img src="/logo.png" alt="Falcon Finserv" className="h-8 sm:h-9 w-auto" />
  </Link>
);

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#0B132B]/90 backdrop-blur-md border-b border-orange-500/20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <FalconMark />
        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <span className="hidden sm:inline text-sm text-slate-400" data-testid="nav-user-name">
                {user.name} · <span className="uppercase text-xs tracking-wider text-[#FF6B00]">{user.role}</span>
              </span>
              {user.role === "admin" ? (
                <>
                  <Button variant="ghost" className="text-white hover:bg-white/10" onClick={() => navigate("/admin")} data-testid="nav-admin-link">
                    <KanbanSquare className="h-4 w-4 mr-2" /> Pipeline
                  </Button>
                  <Button variant="ghost" className="text-white hover:bg-white/10" onClick={() => navigate("/admin/settings")} data-testid="nav-settings-link">
                    <Percent className="h-4 w-4 mr-2" /> Rate cards
                  </Button>
                </>
              ) : (
                <Button variant="ghost" className="text-white hover:bg-white/10" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-link">
                  <LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard
                </Button>
              )}
              <Button variant="outline" className="border-orange-500/30 bg-transparent text-white hover:bg-white/10 hover:text-white" onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout-button">
                <LogOut className="h-4 w-4 mr-2" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="text-white hover:bg-white/10" onClick={() => navigate("/login")} data-testid="nav-login-link">
                Client Login
              </Button>
              <Button className="gold-btn rounded-full px-6" onClick={() => navigate("/register")} data-testid="nav-apply-button">
                Apply Now
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
